/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackDelPaymentOrderRequestSchema } from "./pluginPostbackDelPaymentOrderRequestSchema.ts";

export const callbackPluginDelPaymentCreateStatus200Schema = z.any();

export const callbackPluginDelPaymentCreateResponseSchema = callbackPluginDelPaymentCreateStatus200Schema;

export const callbackPluginDelPaymentCreateDataSchemaJson = pluginPostbackDelPaymentOrderRequestSchema;

export const callbackPluginDelPaymentCreateDataSchemaXml = pluginPostbackDelPaymentOrderRequestSchema;

export const callbackPluginDelPaymentCreateDataSchema = z.union([callbackPluginDelPaymentCreateDataSchemaJson, callbackPluginDelPaymentCreateDataSchemaXml]);
